import React from 'react'
import { PixelRatio } from 'react-native'
import styled, { useTheme } from 'styled-components/native'

import { OfferPlaylistSkeleton, TileSize } from 'ui/components/placeholders/OfferPlaylistSkeleton'
import { SkeletonTile } from 'ui/components/placeholders/SkeletonTile'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { MARGIN_DP, RATIO_BUSINESS } from 'ui/theme'

export const HomeBodyPlaceholder = () => (
  <ViewGap gap={6}>
    <OfferPlaylistSkeleton size={TileSize.LARGE} numberOfTiles={4} />
    <OfferPlaylistSkeleton size={TileSize.MEDIUM} numberOfTiles={5} />
    <Container testID="HomeBodyPlaceholder-testID">
      <BusinessModulePlaceholder />
    </Container>
    <OfferPlaylistSkeleton size={TileSize.MEDIUM} numberOfTiles={5} />
    <OfferPlaylistSkeleton size={TileSize.LARGE} numberOfTiles={4} />
  </ViewGap>
)

const BusinessModulePlaceholder = () => {
  const { appContentWidth, designSystem } = useTheme()
  const width = appContentWidth - 2 * MARGIN_DP
  const height = PixelRatio.roundToNearestPixel(width * RATIO_BUSINESS)
  return (
    <SkeletonTile height={height} width={width} borderRadius={designSystem.size.borderRadius.m} />
  )
}

const Container = styled.View(({ theme }) => ({
  flexDirection: 'row',
  paddingBottom: theme.designSystem.size.spacing.xl,
  paddingLeft: theme.designSystem.size.spacing.xl,
}))
